import { ArrowRight } from 'lucide-react';
import { Link } from 'react-router';

import styles from './StoryCard.module.css';

interface StoryCardProps {
  body: string;
  coverageLine: string;
  ctaHref: string;
  ctaLabel: string;
  eyebrow: string;
  headline: string;
  imageAlt: string;
  imageSrc?: string;
  imageTitle?: string;
  pullQuote: string;
  pullQuoteAttribution: string;
}

export function StoryCard({
  body,
  coverageLine,
  ctaHref,
  ctaLabel,
  eyebrow,
  headline,
  imageAlt,
  imageSrc,
  imageTitle = 'AI-Curated Humanities Course',
  pullQuote,
  pullQuoteAttribution,
}: StoryCardProps) {
  return (
    <article className={styles.card}>
      <div className={styles.copy}>
        <p className={styles.eyebrow}>{eyebrow}</p>
        <div className={styles.text}>
          <h2 className={styles.headline}>{headline}</h2>
          <p className={styles.body}>{body}</p>
        </div>

        <figure className={styles.quoteCard}>
          <span aria-hidden="true" className={styles.quoteMark} data-accent="amber">
            “
          </span>
          <blockquote className={styles.quote}>{pullQuote}</blockquote>
          <figcaption className={styles.attribution}>{pullQuoteAttribution}</figcaption>
        </figure>

        <p className={styles.coverage}>{coverageLine}</p>

        <Link className={styles.cta} to={ctaHref}>
          <span>{ctaLabel}</span>
          <ArrowRight aria-hidden="true" size={16} />
        </Link>
      </div>

      <div className={styles.media}>
        {imageSrc ? (
          <img alt={imageAlt} className={styles.image} loading="lazy" src={imageSrc} />
        ) : (
          <div aria-label={imageAlt} className={styles.placeholder} role="img">
            <div className={styles.placeholderFrame}>
              <span className={styles.placeholderEyebrow}>Course Cover</span>
              <span className={styles.placeholderTitle}>{imageTitle}</span>
            </div>
          </div>
        )}
      </div>
    </article>
  );
}
